<template>
    <div>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
        <v-card color="transparent" flat>
            <v-card-text class="px-0">
                <v-stepper alt-labels v-model="step" class="elevation-0" style="background-color:transparent;">
                    <v-stepper-header class="elevation-0">
                        <v-spacer></v-spacer>
                        <v-stepper-step step="1">
                            {{ $t('geneticsAndBreeding.animalSelection') }}
                        </v-stepper-step>
                        <v-divider ></v-divider>
                        <v-stepper-step step="2" style="white-space: nowrap;position: relative;left: -61px;">
                            {{ $t('geneticsAndBreeding.dataSubmission') }}
                        </v-stepper-step>
                        <v-spacer></v-spacer>
                    </v-stepper-header>
                    <v-stepper-items>
                    <v-stepper-content step="1">
                        <AnimalList @animal-selected="animalSelected"/>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <GeneticAnimalForm @form-updated="formUpdated" v-if="step==2" :animal="selectedAnimal"/>
                    </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
                
            </v-card-text>
        </v-card>
        <DataLostWarning
            :dialogI="dataLossWarning"
            v-if="dataLossWarning"
            @closeDialog="closeWarningMessage"
            @saveData="closeWarningMessage"  
        ></DataLostWarning>
    </div>
</template>

<script>
import AnimalList from "./AnimalList.vue"
import GeneticAnimalForm from "./EPDFormV2.vue" //"./GeneticAnimalForm.vue"

export default {
    components: {
        AnimalList,
        GeneticAnimalForm
    },
    beforeRouteLeave(to, from, next) {
		if(this.formChanged) {
			this.promptToRoute = to;
			this.dataLossWarning = true;
			return
		}else{
            next();
        }
	},
    watch: {
        selectedAnimal: {
            handler() {
                if(this.selectedAnimal.dob == '0000-00-00'){
                    this.selectedAnimal.dob = "";
                }
                // this.selectedAnimal.dob.trim() == '0000-00-00' ? '' : this.selectedAnimal.dob;
                // console.log('skdhfksdhfjkhsdjklfhjksd', this.selectedAnimal)
            },
            deep: true
        }
    },
    data() {
        return {
            dataLossWarning: false,
            formChanged: false,
            promptToRoute: null,
            step: 1,
            selectedAnimal: null,
            breadcrumbs: [
                {
                    text: this.$t('dashboard'),
                    disabled: false,
                    to: "/",
                },
                {
                    text: this.$t('geneticsAndBreeding.geneticsAndBreeding'),
                    disabled: true,
                    to: { name: "Genetics" },
                },
            ],
        }
    },
    methods:  {
        formUpdated(st) {
            console.log('ssss', st)
            this.formChanged = st;
        },
        closeWarningMessage(stay) {
            this.dataLossWarning = false;
            if(!stay) {
                this.formChanged = false;
                this.$router.push(this.promptToRoute)
            }
        },
        animalSelected(animal) {
            this.selectedAnimal = animal[0]
            this.step = 2
        }
    }
}
</script>